import { useState } from 'react';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import UserInitials, { UserInitialsProps } from '@/trio-ui/UserInitials';
import { Container } from './UserInitialsInputFile.styles';
import PictureUpload, { SelectedImageData, Props as PictureUploadProps } from '../PictureUpload';

export type ImageUploaderValue = SelectedImageData;

type Props = UserInitialsProps &
  Pick<PictureUploadProps, 'disableFileInput' | 'disableUrlInput'> & {
    initialPictureUrl?: string;
    value?: ImageUploaderValue;
    onChange?: (value: ImageUploaderValue) => void;
    isOpen?: boolean;
    setIsOpen?: (value: boolean) => void;
  };

const ImageUploaderInputFile = ({
  initialPictureUrl,
  value,
  onChange,
  isOpen: externalIsOpen,
  setIsOpen: externalSetIsOpen,
  disableFileInput,
  disableUrlInput,
  ...userInitialsProps
}: Props): JSX.Element => {
  const [internalIsModalOpen, setInternalIsModalOpen] = useState<boolean>(false);

  const isModalOpen = externalIsOpen ?? internalIsModalOpen;
  const setIsModalOpen = externalSetIsOpen ?? setInternalIsModalOpen;

  const onSelectedPicture = (images: SelectedImageData): void => {
    onChange?.(images);
    setIsModalOpen(false);
  };

  const hasValue = value && (value.imageUrl || value.imageFiles.length > 0);

  const handleClick = (): void => {
    if (!hasValue) {
      setIsModalOpen(true);
    } else {
      onChange?.({
        imageUrl: '',
        imageFiles: [],
      });
    }
  };

  const renderIcon = (): JSX.Element => {
    if (hasValue) {
      return <DeleteIcon />;
    }

    if (initialPictureUrl) {
      return <EditIcon />;
    }

    return <AddAPhotoIcon />;
  };

  return (
    <>
      <Container onClick={handleClick}>
        <UserInitials
          {...userInitialsProps}
          pictureUrl={value?.imageUrl || value?.imageFiles[0]?.dataURL || initialPictureUrl}
        />
        {renderIcon()}
      </Container>
      <PictureUpload
        onClose={() => setIsModalOpen(false)}
        isOpen={isModalOpen}
        onSelectCandidateProfilePicture={onSelectedPicture}
        disableFileInput={disableFileInput}
        disableUrlInput={disableUrlInput}
      />
    </>
  );
};

export default ImageUploaderInputFile;
